import { store } from '@/app/app-store';
import { env } from '@/environments';
import { Route } from 'vue-router';

export const oidcMiddleware = (to: Route, from: Route, next: Function) => {
  if (!to.meta.isPublic)
    store
      .dispatch(`${env.oidcModule}/oidcCheckAccess`, to)
      .then((hasAccess: boolean) => hasAccess && next());
  else next();
};
